import api from "@/lib/api";

// Ruta de la horma (debe coincidir con backend/core/hormas.py): se capturan medidas y fotos y se da de alta (ya se usa
// en los modelos) y queda "Revisado"; con el archivo "Pull Over & Prueba de Calce" adjunto se libera.
// Una modificación la deja "en_modificacion" hasta que se vuelve a dar de alta con el motivo de la corrección.
export const RUTA = [
  { key: "obtencion_medidas", label: "Captura de medidas" },
  { key: "dada_de_alta", label: "Revisado" },
  { key: "liberada", label: "Liberada" },
];
// Archivo que se adjunta con la horma revisada para liberarla: tipo → [etiqueta, columna con el vigente].
export const DOCS_LIBERAR = { carta_pull_over: ["Pull Over & Prueba de Calce", "carta_pull_over_id"] };
// Historial: formato_calce es el formato de prueba de calce por separado de antes.
export const DOC_LABEL = { carta_pull_over: "Pull Over & Prueba de Calce", formato_calce: "Prueba de calce" };

// Cuadros de validación del FDD-08 (debe coincidir con VALIDACION del backend).
export const VALIDACION = [
  { key: "suela_central", titulo: "Validación de suela central", puntos: [["cavidad_interna", "Cavidad interna"], ["piso", "Piso"], ["acabado", "Acabado"]] },
  { key: "corrida_suela", titulo: "Validación de corrida de suela", puntos: [["cavidad_interna", "Cavidad interna"], ["piso", "Piso"], ["acabado", "Acabado"]] },
  { key: "planta_central", titulo: "Validación de planta central", puntos: [["contorno", "Contorno de la planta"], ["quiebre_cambrellon", "Quiebre del cambrellon"], ["conformado", "Conformado"], ["biselado", "Biselado"]] },
  { key: "corrida_plantas", titulo: "Validación de corrida de plantas", puntos: [["contorno", "Contorno de la planta"], ["quiebre_cambrellon", "Quiebre del cambrellon"], ["conformado", "Conformado"], ["biselado", "Biselado"]] },
];
export const MAX_OBSERVACIONES = 400;

export function estadoHorma(h) {
  if (!h) return { label: "—", cls: "bg-slate-100 text-slate-600" };
  if (!h.activa) return { label: "Inactiva", cls: "bg-slate-200 text-slate-600" };
  if (h.etapa === "liberada") return { label: "Liberada", cls: "bg-emerald-100 text-emerald-700" };
  if (h.etapa === "dada_de_alta") return { label: "Revisado", cls: "bg-blue-100 text-blue-700" };
  if (h.etapa === "en_modificacion") return { label: "En modificación", cls: "bg-orange-100 text-orange-800" };
  return { label: "En captura de medidas", cls: "bg-amber-100 text-amber-800" };
}

// Ficha de la horma agrupada como se captura. Las medidas y la suela/planta salen en el formato FDD-08.
// [campo, etiqueta corta (un renglón), tipo, ayuda]. tipo "auto" = lo pone el PLM (no se edita).
export const GRUPOS = [
  {
    titulo: "Identificación",
    campos: [
      ["codigo", "Código"], ["nombre", "Nombre"], ["proveedor", "Hormero"],
      ["genero", "Género"], ["corrida", "Corrida"], ["altura_tacon", "Altura de tacón"],
      ["tipo_punta", "Tipo de punta"], ["horma_referencia", "Horma de referencia", null, "Horma central o de referencia"], ["ubicacion", "Ubicación física"],
      ["fecha_alta", "Fecha de alta", "auto", "Se asigna sola al dar de alta la horma"], ["fecha_marcada", "Fecha marcada", "fecha", "La fecha que trae impresa la horma"],
    ],
  },
  {
    titulo: "Medidas",
    campos: [
      ["central", "Central (talla)"], ["largo", "Largo"], ["graduacion", "Graduación"],
      ["recio", "Recio"], ["cintura", "Cintura"], ["empeine", "Empeine"],
      ["spring", "Spring"], ["punto", "Punto"],
    ],
  },
  {
    titulo: "Suela y planta central",
    campos: [
      ["proveedor_suela", "Proveedor de suela"], ["proveedor_planta", "Proveedor de planta"], ["plantilla_unificada", "Plantilla unificada"],
      ["esponja_plantilla", "Esponja de plantilla"], ["fecha_solicitud_madera", "Solicitud (madera)", null, "Fecha de solicitud de la madera o 'Desarrollo interno'"], ["fecha_entrega", "Fecha de entrega"],
    ],
  },
];
export const LIBRES_LIBERADA = ["ubicacion", "notas", "fecha_marcada"];

export const puedeEditarHormas = (user) => !!user && (user.es_admin || (user.perms?.fases || []).includes("Desarrollo · Horma"));
// Piden modificar una horma revisada o liberada: Diseño y Desarrollo (además de quien edita hormas).
export const puedePedirModificacion = (user) => !!user && (puedeEditarHormas(user) || ["diseno", "desarrollo"].includes(user.role));

export async function descargarFdd08(horma) {
  const r = await api.get(`/hormas/${horma.id}/fdd08`, { responseType: "blob" });
  const nombre = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || `FDD-08_${horma.codigo}.xlsx`;
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  a.click();
  URL.revokeObjectURL(url);
}
